import React, { useEffect, useState } from "react";
import FilterButton from "./FilterButton";
import AppointmentModal from './AppointmentModal';

const API_BASE = "https://bunny-klawz.uc.r.appspot.com";

const detailKeys = [
    "Service", "Length", "Design", "Soak-Off", "Preferred Nail Tech", "Appointment Slot", "Cancellation Details"
]

const Appointments = ({ isOpen, setIsOpen, menuRef }) => {
    const [appointments, setAppointments] = useState([]);
    const [filteredAppointments, setFilteredAppointments] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [statusFilter, setStatusFilter] = useState("");
    const [nailTechFilter, setNailTechFilter] = useState("");
    const [dateFilter, setDateFilter] = useState("");
    const [customDateRange, setCustomDateRange] = useState({ start: "", end: "" });
    const [activeRequestId, setActiveRequestId] = useState(null);
    const [emailStatusMap, setEmailStatusMap] = useState({});
    const [reasonModal, setReasonModal] = useState({
        visible: false,
        appointmentId: null,
        action: "", // 'cancel' or 'reject'
    });
    const [reasonInput, setReasonInput] = useState("");


    const handleRequestClick = (id) => {
        setActiveRequestId(prev => prev === id ? null : id); // toggle
    };

    useEffect(() => {
        const fetchAppointments = async () => {
            try {
                const response = await fetch("https://bunny-klawz.uc.r.appspot.com/appointments");
                const data = await response.json();
                setAppointments(
                    data
                        .filter(appt => appt.paymentComplete === true)
                        .reverse()
                );
            } catch (error) {
                console.error("Error fetching appointments:", error);
            }
        };
        fetchAppointments();
    }, []);

    useEffect(() => {
        const checkEmailStatus = async () => {
            const statuses = {};

            await Promise.all(appointments.map(async (appt) => {
                if (appt.status === "cancelled") {
                    try {
                        const response = await fetch(`https://bunny-klawz.uc.r.appspot.com/email-status/${appt._id}`);
                        const data = await response.json();
                        statuses[appt._id] = data.sent;
                    } catch (err) {
                        console.error(`Failed to fetch email status for ${appt._id}`, err);
                        statuses[appt._id] = true; // assume sent if error
                    }
                }
            }));

            setEmailStatusMap(statuses);
        };

        checkEmailStatus();
    }, [appointments]);

    useEffect(() => {
        const lowerQuery = searchQuery.toLowerCase();

        const filtered = appointments.filter((appt) => {
            const name = appt.user?.name?.toLowerCase() || "";
            const email = appt.user?.email?.toLowerCase() || "";
            const instagram = appt.instagram?.toLowerCase() || "";
            const status = appt.status?.toLowerCase() || "";

            const detailsMatch = appt.appointmentDetails?.some(detail => {
                if (typeof detail === "string") {
                    return detail.toLowerCase().includes(lowerQuery);
                } else if (typeof detail === "object" && detail !== null) {
                    return Object.values(detail).some(value =>
                        typeof value === "string" && value.toLowerCase().includes(lowerQuery)
                    );
                }
                return false;
            });

            return (
                name.includes(lowerQuery) ||
                email.includes(lowerQuery) ||
                instagram.includes(lowerQuery) ||
                status.includes(lowerQuery) ||
                detailsMatch
            );
        });

        setFilteredAppointments(filtered);
    }, [searchQuery]);

    function formatDate(timestamp) {
        const date = new Date(timestamp);

        // Get formatted date components
        const formattedDate = date.toLocaleString("en-US", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric"
        });

        // Extract timezone abbreviation
        const timeZone = date.toLocaleTimeString("en-US", { timeZoneName: "short" }).split(" ").pop();

        return `${formattedDate} (${timeZone})`;
    }

    function formatTime(timestamp) {
        const date = new Date(timestamp);

        // Get formatted date components
        const formattedDate = date.toLocaleString("en-US", {
            hour: "numeric",
            minute: "numeric",
            ampm: "long"
        });

        // Extract timezone abbreviation
        const timeZone = date.toLocaleTimeString("en-US", { timeZoneName: "short" }).split(" ").pop();

        return `${formattedDate}`;
    }

    function capitalize(s) {
        return String(s[0]).toUpperCase() + String(s).slice(1);
    }

    const convertUTCToLocal = (utcString) => {
        if (!utcString) return "N/A";
        return new Date(utcString).toLocaleString();
    };

    const Cancellation = async (appointmentId, action) => {

        if (action === 'cancel') {
            const response = await fetch(`https://bunny-klawz.uc.r.appspot.com/appointments/${appointmentId}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ status: "cancelled" }),
            });

            if (!response.ok) throw new Error("Failed to update appointment status");

            const updatedAppointment = await response.json();

            // Choose email content based on status
            let emailSubject = "";
            let emailMessage = "";


            emailSubject = "Your appointment has been cancelled.";
            // emailMessage = `Hi ${updatedAppointment.user.name}, your appointment on ${updatedAppointment.localDateTime} has been cancelled. If this was a mistake, please book again.`;
            emailMessage = `Your appointment for ${updatedAppointment.appointmentDetails[0]} on ${updatedAppointment.localDateTime} has been cancelled. If this was a mistake or you’d like to reschedule, you can book a new appointment at https://bunnyklawz.com.\n\nPlease do not respond back. This is an automated message. Replies will not be checked.\nPlease reach out via Instagram @bunnyklaws for any questions.`;


            // Send email via backend
            const cancellationResponse = await fetch("https://bunny-klawz.uc.r.appspot.com/schedule-email", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    emailId: appointmentId,
                    toEmail: updatedAppointment.user.email, // make sure this field exists
                    toName: updatedAppointment.user.name,
                    subject: emailSubject,
                    message: emailMessage,
                }),
            });

            if (!cancellationResponse.ok) throw new Error("Failed to update appointment status");

            setAppointments((prev) =>
                prev.map((appt) => (appt._id === appointmentId ? updatedAppointment : appt))
            );

            setTimeout(() => {
                fetch(`https://bunny-klawz.uc.r.appspot.com/email-status/${appointmentId}`)
                    .then(res => res.json())
                    .then(data => {
                        setEmailStatusMap(prev => ({
                            ...prev,
                            [appointmentId]: data.sent
                        }));
                    });
            }, 2000);

        }

        if (action === 'undo') {
            const response = await fetch(`https://bunny-klawz.uc.r.appspot.com/appointments/${appointmentId}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ status: "confirmed" }),
            });

            if (!response.ok) throw new Error("Failed to update appointment status");

            const updatedAppointment = await response.json();

            // Send email via backend
            const cancellationResponse = await fetch("https://bunny-klawz.uc.r.appspot.com/cancel-email", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    emailId: appointmentId
                }),
            });

            if (!cancellationResponse.ok) throw new Error("Failed to update appointment status");

            setAppointments((prev) =>
                prev.map((appt) => (appt._id === appointmentId ? updatedAppointment : appt))
            );
        }

    }

    const handleCancellationWithReason = async (appointmentId, reason) => {
        const cancellationTime = new Date().toISOString();

        const response = await fetch(`${API_BASE}/appointments/${appointmentId}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                status: "cancelled",
                appointmentDetails: [
                    ...appointments.find(a => a._id === appointmentId).appointmentDetails.slice(0, 6),
                    { cancellationReason: reason, cancellationTime }
                ]
            }),
        });

        const updated = await response.json();

        await fetch(`${API_BASE}/schedule-email`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                emailId: appointmentId,
                toEmail: updated.user.email,
                toName: updated.user.name,
                subject: "Your appointment has been cancelled.",
                message: `Your appointment for ${updated.appointmentDetails[0]} on ${updated.localDateTime} has been cancelled. If this was a mistake or you’d like to reschedule, you can book a new appointment at https://bunnyklawz.com.\n\nPlease do not respond back. This is an automated message. Replies will not be checked.\nPlease reach out via Instagram @bunnyklaws for any questions.`,
            }),
        });

        setAppointments((prev) =>
            prev.map((appt) => (appt._id === appointmentId ? updated : appt))
        );
    };

    const handleRejectionWithReason = async (appointmentId, reason) => {
        const rejectionTime = new Date().toISOString();

        const response = await fetch(`${API_BASE}/appointments/${appointmentId}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                status: "rejected",
                appointmentDetails: [
                    ...appointments.find(a => a._id === appointmentId).appointmentDetails.slice(0, 6),
                    { rejectionReason: reason, rejectionTime }
                ]
            }),
        });

        const updated = await response.json();

        await fetch(`${API_BASE}/send-email`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                toEmail: updated.user.email,
                toName: updated.user.name,
                subject: "Your appointment has been rejected.",
                message: `We regret to inform you that we are unable to accommodate your appointment request for ${updated.appointmentDetails[0]} on ${updated.localDateTime}. We apologize for the inconvenience.\n\nPlease do not respond back. This is an automated message. Replies will not be checked.\nPlease reach out via Instagram @bunnyklaws for any questions.`,
            }),
        });

        setAppointments((prev) =>
            prev.map((appt) => (appt._id === appointmentId ? updated : appt))
        );
    };

    const updateAppointmentStatus = async (appointmentId, newStatus) => {
        try {
            const response = await fetch(`https://bunny-klawz.uc.r.appspot.com/appointments/${appointmentId}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ status: newStatus }),
            });

            if (!response.ok) throw new Error("Failed to update appointment status");

            const updatedAppointment = await response.json();

            // Choose email content based on status
            let emailSubject = "";
            let emailMessage = "";

            if (newStatus === "confirmed") {
                emailSubject = "Your appointment has been confirmed!";
                // emailMessage = `Hi ${updatedAppointment.user.name}, your appointment on ${updatedAppointment.localDateTime} has been confirmed.`;
                emailMessage = `Great news, ${updatedAppointment.user.name}! Your appointment for ${updatedAppointment.appointmentDetails[0]} on ${updatedAppointment.localDateTime} is confirmed.💖💅\n\n We moved to a new location! See you soon! 💖\n\n📍 706 W Southern Ave #102 Mesa AZ\n\nPlease do not respond back. This is an automated message. Replies will not be checked.\nPlease reach out via Instagram @bunnyklawz for any questions.`;
            } else if (newStatus === "rejected") {
                emailSubject = "Your appointment has been rejected.";
                // emailMessage = `Hi ${updatedAppointment.user.name}, unfortunately, your appointment on ${updatedAppointment.localDateTime} has been rejected. Please reschedule.`;
                emailMessage = `We regret to inform you that we are unable to accommodate your appointment request for ${updatedAppointment.appointmentDetails[0]} on ${updatedAppointment.localDateTime}. We apologize for the inconvenience.\n\nPlease do not respond back. This is an automated message. Replies will not be checked.\nPlease reach out via Instagram @bunnyklaws for any questions.`;
            } else if (newStatus === "cancelled") {
                emailSubject = "Your appointment has been cancelled.";
                // emailMessage = `Hi ${updatedAppointment.user.name}, your appointment on ${updatedAppointment.localDateTime} has been cancelled. If this was a mistake, please book again.`;
                emailMessage = `Your appointment for ${updatedAppointment.appointmentDetails[0]} on ${updatedAppointment.localDateTime} has been cancelled. If this was a mistake or you’d like to reschedule, you can book a new appointment at https://bunnyklawz.com.\n\nPlease do not respond back. This is an automated message. Replies will not be checked.\nPlease reach out via Instagram @bunnyklaws for any questions.`;
            }

            // Send email via backend
            await fetch("https://bunny-klawz.uc.r.appspot.com/send-email", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    toEmail: updatedAppointment.user.email, // make sure this field exists
                    toName: updatedAppointment.user.name,
                    subject: emailSubject,
                    message: emailMessage,
                }),
            });

            setAppointments((prev) =>
                prev.map((appt) => (appt._id === appointmentId ? updatedAppointment : appt))
            );
        } catch (error) {
            console.error("Error updating appointment:", error);
        }
    };

    return (
        <div className="Appointments">
            {/* <h2>Appointments</h2> */}
            <div className="Functions">
                <div className="FunctionsLeft">
                    <input
                        className="Search"
                        type="text"
                        placeholder="Search by anything you can think of!"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                </div>
                <div className="FunctionsRight">

                    {/* <button>+</button> */}
                    <button onClick={() => setShowModal(true)} className="open-btn">Schedule Appointment</button>
                    <FilterButton appointments={appointments} setFilteredAppointments={setFilteredAppointments} isOpen={isOpen} setIsOpen={setIsOpen} menuRef={menuRef} />

                    <AppointmentModal showModal={showModal} setShowModal={setShowModal} />
                </div>

            </div>

            {filteredAppointments.length > 0 ? (
                <ul className="RequestList">
                    {filteredAppointments.map((appointment) => {
                        const isActive = activeRequestId === appointment._id;

                        return (
                            <li
                                key={appointment._id}
                                className={`Request ${isActive ? "activeRequest" : ""}`}
                                onClick={() => handleRequestClick(appointment._id)}
                            >
                                <div className="SurfaceDetails">
                                    <br />
                                    <p className="SurfaceDetailsText">
                                        {formatDate(appointment.appointmentDetails[5].date)} - {capitalize(appointment.status) || "Unknown"} - {appointment.user?.name || "Unknown"} - {formatTime(appointment.appointmentDetails[5].date)} with {appointment.appointmentDetails[5].artist}
                                    </p>
                                    <div className={`Actions`}>
                                        {appointment.status === "confirmed" &&
                                            new Date(appointment.appointmentDetails[5].date) >= new Date() && (
                                                <button onClick={() =>
                                                    setReasonModal({ visible: true, appointmentId: appointment._id, action: "cancel" })
                                                }>
                                                    Cancel Appointment
                                                </button>
                                            )
                                        }

                                        {appointment.status === "pending" && (
                                            <>
                                                <button onClick={() => updateAppointmentStatus(appointment._id, "confirmed")}>Confirm</button>
                                                <button onClick={() =>
                                                    setReasonModal({ visible: true, appointmentId: appointment._id, action: "reject" })
                                                }>
                                                    Reject
                                                </button>
                                            </>
                                        )}
                                        {appointment.status === "cancelled" && emailStatusMap[appointment._id] === false && (
                                            <button onClick={() => Cancellation(appointment._id, "undo")}>Undo Cancellation</button>
                                        )}
                                    </div>
                                </div>
                                <div className="RequestDetails">
                                    <div className="RequestDetailsSection">
                                        <strong>Appointment Details:</strong>
                                        <ul>
                                            {
                                                appointment.appointmentDetails?.map((detail, index) => {
                                                    if (typeof detail === 'object' && detail !== null) {
                                                        return (
                                                            <React.Fragment key={index}>
                                                                {detail.artist && <li>Assigned Nail Tech: {detail.artist}</li>}
                                                                {detail.duration && <li>Duration: {detail.duration}</li>}
                                                            </React.Fragment>
                                                        );
                                                    } else if (detail !== null) {
                                                        return <li key={index}>{detailKeys[index]}: {detail}</li>;
                                                    }
                                                    return null;
                                                })}
                                        </ul>
                                    </div>
                                    {appointment.appointmentDetails[6]?.cancellationReason ? (<>

                                        <div className="RequestDetailsSection">
                                            <strong>Cancellation Details</strong>
                                            <ul>
                                                {appointment.appointmentDetails?.map((detail, index) => {
                                                    if (typeof detail === 'object' && detail !== null && index === 6) {
                                                        return (
                                                            <React.Fragment key={index}>
                                                                {detail.cancellationReason && <li>Reason: {detail.cancellationReason}</li>}
                                                                {detail.cancellationTime && <li>Cancelled On: {new Date(detail.cancellationTime).toLocaleString()}</li>}
                                                            </React.Fragment>
                                                        );
                                                    }
                                                    return null;
                                                })}
                                            </ul>
                                        </div>
                                    </>) : appointment.appointmentDetails[6]?.rejectionReason ? (<>
                                        <div className="RequestDetailsSection">
                                            <strong>Rejection Details</strong>
                                            <ul>
                                                {appointment.appointmentDetails?.map((detail, index) => {
                                                    if (typeof detail === 'object' && detail !== null && index === 6) {
                                                        return (
                                                            <React.Fragment key={index}>
                                                                {detail.rejectionReason && <li>Reason: {detail.rejectionReason}</li>}
                                                                {detail.rejectionTime && <li>Rejected On: {new Date(detail.rejectionTime).toLocaleString()}</li>}
                                                            </React.Fragment>
                                                        );
                                                    }
                                                    return null;
                                                })}
                                            </ul>
                                        </div>
                                    </>) : (<></>)}
                                </div>




                            </li>
                        );
                    }).reverse()}
                </ul>
            ) : (
                <p>No Appointments Found...</p>
            )}
            {reasonModal.visible && (
                <div className="modal-overlay AppointmentsCancelModal">
                    <div className="modal-content ModalBox">
                        <h2 className="cancellationTitle">{reasonModal.action === "cancel" ? "Appointment Cancellation" : "Appointment Rejection"}</h2>
                        {reasonModal.action === "cancel" ? (<>
                            <p className="cancellationWarningText">Are you sure you want to cancel the client’s appointment? Canceled appointments can only be undone within the past 5 minutes and if slot is still available.</p>
                            <p className="cancellationWarningText">Reason for cancellation:</p>
                        </>) : (<>
                            <p className="cancellationWarningText">Are you sure you want to reject request? Once rejected, the client will have to request for an appointment again</p>
                            <p className="cancellationWarningText">Reason for rejecting request:</p>
                        </>)}

                        <textarea
                            value={reasonInput}
                            onChange={(e) => setReasonInput(e.target.value)}
                            placeholder="Enter reason here..."
                            rows={4}
                        />
                        <div className="modal-actions DetailsBoxActions">
                            <button onClick={() => setReasonModal({ ...reasonModal, visible: false })} className="modal-close cancellingClose">
                                <img
                                    className="close-button-icon"
                                    src="/images/CloseButton.png"
                                    alt="Close Button Icon"
                                />
                            </button>
                            <button onClick={() => setReasonModal({ ...reasonModal, visible: false })}>Go Back</button>
                            <button
                                onClick={() => {
                                    if (reasonModal.action === "cancel") {
                                        handleCancellationWithReason(reasonModal.appointmentId, reasonInput);
                                    } else {
                                        handleRejectionWithReason(reasonModal.appointmentId, reasonInput);
                                    }
                                    setReasonModal({ visible: false, appointmentId: null, action: "" });
                                    setReasonInput("");
                                }}
                            >
                                {(reasonModal.action === "cancel") ? 'Confirm' : 'Reject'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Appointments;